import { FinancialProfile } from '../../../member-profile/components/FinancialProfile';

const FinancialProfilePage = () => {
    return <FinancialProfile />;
};

export default FinancialProfilePage;
